import moment from 'moment';

function dealSortKey(deal) {
  const effective = deal?.effectiveDate ? moment(deal.effectiveDate).valueOf() : 0;
  const created = deal?.createdAt ? moment(deal.createdAt).valueOf() : 0;
  return { effective, created };
}

export function pickLatestDeal(deals = []) {
  if (!deals.length) {
    return null;
  }
  return [...deals].sort((a, b) => {
    const keyA = dealSortKey(a);
    const keyB = dealSortKey(b);
    if (keyB.effective !== keyA.effective) {
      return keyB.effective - keyA.effective;
    }
    return keyB.created - keyA.created;
  })[0];
}

export function marketingViewIdForFunding(deal) {
  const id = deal?.marketingViewId;
  if (id == null || String(id).trim() === '') {
    return undefined;
  }
  return String(id).trim();
}

export function normalizeFundingPercentage(value) {
  if (value == null || value === '') {
    return null;
  }
  const num = Number(value);
  if (!Number.isFinite(num) || num <= 0) {
    return null;
  }
  if (num > 0 && num <= 1) {
    return num * 100;
  }
  return num;
}
